module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('prism-editor', {
    staticClass: "code-editor m-0 p-0",
    attrs: {
      "highlight": _vm.highlighter,
      "line-numbers": _vm.lineNumbers,
      "readonly": _vm.readonly
    },
    on: {
      "input": _vm.change
    },
    model: {
      value: (_vm.code),
      callback: function($$v) {
        _vm.code = $$v
      },
      expression: "code"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33ee90b7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/CodeEditor.vue
// module id = 2140
// module chunks = 1